// FeedbackForm Component
// Collects a visitor's email + message and sends it to Formspree, which
// emails it to the site owner and stores every submission in the Formspree
// dashboard (so collected emails can be exported later).

import React, { useState } from 'react';
import './FeedbackForm.css';

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/mqeoknny';

const FeedbackForm = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (status === 'sending') return;

    setStatus('sending');

    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          email,
          message,
          _subject: 'One Piece Trivia feedback',
        }),
      });

      if (response.ok) {
        setStatus('sent');
        setEmail('');
        setMessage('');
      } else {
        setStatus('error');
      }
    } catch (err) {
      console.error('Feedback send failed:', err);
      setStatus('error');
    }
  };

  return (
    <div className="feedback-form-container">
      <h2 className="feedback-title">Talk to the Crew</h2>
      <p className="feedback-subtitle">
        Suggest a quiz question, report a wrong answer, or just say hi. Drop your
        email and we'll get back to you.
      </p>

      <form onSubmit={handleSubmit} className="feedback-form">
        <input
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email..."
          required
          disabled={status === 'sending'}
        />
        <textarea
          name="message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Your message, suggestion, or question..."
          rows={3}
          required
          disabled={status === 'sending'}
        />
        <button type="submit" disabled={status === 'sending'}>
          {status === 'sending' ? 'Sending...' : 'Send'}
        </button>
      </form>

      {status === 'sent' && (
        <div className="feedback-message success">
          ✨ Thanks! Your message reached the crew.
        </div>
      )}
      {status === 'error' && (
        <div className="feedback-message error">
          Something went wrong. Please try again in a moment.
        </div>
      )}
    </div>
  );
};

export default FeedbackForm;
